export const Nationalities = [
    { label: 'Afghan', value: 'af', code:'+93', country:'Afghanistan' },
    { label: 'Americain', value: 'am', code:'+1', country:'Amérique' },
    { label: 'Albanais', value: 'ab', code:'+355', country:'Albanie' },
    { label: 'Algérien', value: 'ag', code:'+213', country:'Algérie' },
    { label: 'Allemand', value: 'al', code:'+49', country:'Allemagne' },
    { label: 'Australien', value: 'aus', code:'+61', country:'Australie' },
    { label: 'Autrichien', value: 'aut', code:'+43', country:'Autriche' },
    { label: 'Bolivien', value: 'bo', code:'+591', country:'Bolivie' },
    { label: 'Brésilien', value: 'br', code:'+55', country:'Brésil' },
    { label: 'Bulgare', value: 'bu', code:'+359', country:'Bulgarie' },
    { label: 'Canadien', value: 'ca', code:'+1', country:'Canada' },
    { label: 'Chinois', value: 'ch', code:'+86', country:'Chine' },
    { label: 'Colombien', value: 'col', code:'+57', country:'Colombie' },
    { label: 'Coréen', value: 'cor', code:'+82', country:'Corée' },
    { label: 'Ivoirien', value: 'iv', code:'+225', country:'Côte d\'ivoire'  },
    { label: 'Croate', value: 'cr', code:'+385', country:'Croatie' },
    { label: 'Cubain', value: 'cu', code:'+53', country:'Cuba' },
    { label: 'Danois', value: 'da', code:'+45', country:'Danemark' },
    { label: 'Egyptien', value: 'eg', code:'+20', country:'Egypt' },
    { label: 'Espagnol', value: 'es', code:'+34', country:'Espagne' },
    { label: 'Français', value: 'fr', code:'+33', country:'France' },
    { label: 'Grec', value: 'gr', code:'+30', country:'Grèce' },
    { label: 'Indien', value: 'in', code:'+91', country:'Inde' },
    { label: 'Irlandais', value: 'ir', code:'+353', country:'Irlande' },
    { label: 'Italien', value: 'it', code:'+39', country:'Italie' },
    { label: 'Japonais', value: 'ja', code:'+81', country:'Japon' },
    { label: 'Libanais', value: 'li', code:'+231', country:'Liban' },
    { label: 'Marocain', value: 'ma', code:'+212', country:'Maroc' },
    { label: 'Mexicain', value: 'me', code:'+52', country:'Mexique' },
    { label: 'Nigerien', value: 'ni', code:'+234', country:'Nigeria' },
    { label: 'Pakistanais', value: 'pa', code:'+92', country:'Pakistan' },
    { label: 'Néerlandais', value: 'ne', code:'+31', country:'Pays-Bas' },
    { label: 'Polonais', value: 'pol', code:'+48', country:'Pologne' },
    { label: 'Portugais', value: 'por', code:'+351', country:'Portugal' },
    { label: 'Roumain', value: 'ro', code:'+40', country:'Roumanie' },
    { label: 'Britanique', value: 'br', code:'+44', country:'Grande bretagne' },
    { label: 'Russe', value: 'ru', code:'+7', country:'Russie' },
    { label: 'Sénégalais', value: 'sen', code:'+221', country:'Sénégal' },
    { label: 'Serbe', value: 'ser', code:'+381', country:'Serbie' },
    { label: 'Suedois', value: 'sue', code:'+46', country:'Suède' },
    { label: 'Suisse', value: 'sui', code:'+41', country:'Suisse' },
    { label: 'Turque', value: 'tu', code:'+90', country:'Turquie' },
    { lable: 'Tunisien', value:'tun', code:'+216', country:'Tunisie'},
    { label: 'Vietnamien', value: 'vi', code:'+84', country:'Vietnam' },
]



// WEBPACK FOOTER //
// ./src/config/enum/Nationalities.js